export default __webpack_public_path__ + "static/media/stroller_pizza.3cbe4b64.png";